<section ngClass="{{ backgroundStyleClass }}">
  <div #ref fxLayout="row" fxLayoutAlign="{{ alignItemsH }} {{ alignItemsV }}">
    <div class="section-col">
      <ng-content select="[first]"></ng-content>
    </div>
    <div *ngIf="isSecondContentVisible" class="section-col">
      <ng-content select="[second]"></ng-content>
    </div>
    <div *ngIf="isThirdContentVisible" class="section-col">
      <ng-content select="[third]"></ng-content>
    </div>
    <div *ngIf="isForthContentVisible" class="section-col">
      <ng-content select="[fourth]"></ng-content>
    </div>
  </div>
</section>
